// extracted by css-extract-rspack-plugin
export default {"wrapper":"IOg33OBcEKIMBGyT","header":"hgLbyI8aL_Q_DOsb","section":"XaIkOZWZQ58D4jAf","divider":"QKJsgtRJP7cngVnp"};